import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { throttleMiddleware } from '../../../request-middlewares/throttelMiddleware.js';
import { resolveConfirmSBInRegistrationForm } from '../server/resolveConfirmSBInRegistrationForm.js';

@Entity()
export class ConfirmedSBInRegistrationForm extends MongoEntity {
  static override _class = 'ConfirmedSBInRegistrationForm';
  static override _collectionName = 'confirmed-sb-in-registration-form-tickets';

  @Field(type => String)
  email!: string;

  @Field(type => String)
  userID: Maybe<string>;

  @Field(type => Boolean, { default: v => v ?? false })
  confirmed!: boolean;

  // this field will have an ID of the child, if this field is set the confirmation should add the relationship to the child and delete the tracker
  @Field(type => ID)
  shouldCreateRelationshipToChild: Maybe<string>;

  // with this token the user can retrieve the user data
  @Field(type => String)
  token: Maybe<string>;
}

export const confirmSBInRegistrationForm = registerQuery({
  operationName: 'confirmSBInRegistrationForm',
  type: () => String,
  params: [
    { type: () => String, name: 'email' },
    { type: () => String, name: 'schoolID' },
  ],
  middlewares: [throttleMiddleware(5000)],
  resolve: resolveConfirmSBInRegistrationForm,
});

export const subscribeToConfirmedSBInRegistrationFormTracker = registerSubscription({
  operationName: 'subscribeToConfirmedSBInRegistrationFormTracker',
  middlewares: [
    publicOperationMiddleware(
      'Teil der oeffentlichen SB-Bestaetigung. TODO: filtert nicht auf den Aufrufer, gibt das Tracker-Token heraus',
    ),
  ],
  type: () => [ConfirmedSBInRegistrationForm],
  params: [{ type: () => [String], name: 'trackerIDs' }],
  resolve: (trackerIDs: string[]) => (gqlFields: BaseQLSelectionSet<ConfirmedSBInRegistrationForm>) =>
    watchQuery<ConfirmedSBInRegistrationForm>(
      ConfirmedSBInRegistrationForm._collectionName,
      { _id: { $in: trackerIDs } },
      { projection: gqlFields },
    ),
});
